import { Alert, Button, Card } from './components';

// The panel the guide and the signatory use to invite their group (DR-405). Presentational: it shows the state of the group's
// activation link and calls back; fetching the link and sharing it belong to the app (see @rooming/web-core `invitation`).

export type InvitationClosedReason = 'GROUP_CLOSED' | 'NO_TRIP_DATE' | 'EXPIRED' | 'EVERYONE_ACTIVE';

const CLOSED_TEXT: Record<InvitationClosedReason, string> = {
  EVERYONE_ACTIVE: 'Todos los integrantes ya activaron su cuenta: el enlace se cerró solo.',
  EXPIRED: 'El enlace venció. Desde ahora solo un administrador de Funtour puede dar de alta o activar personas.',
  NO_TRIP_DATE: 'El enlace se habilita cuando el grupo tiene fecha de viaje. Avisale a Funtour.',
  GROUP_CLOSED: 'El grupo está cerrado: el enlace no está disponible.',
};

export interface InvitationPanelProps {
  readonly open: boolean;
  readonly closedReason: InvitationClosedReason | null;
  /** People who can activate through the link, and how many of them have not yet. */
  readonly total: number;
  readonly pending: number;
  /** Last day the link works, already formatted for the person ("12 de noviembre"). */
  readonly closesOnText?: string | undefined;
  readonly onShare: () => void;
  readonly onCopy: () => void;
}

export function InvitationPanel({
  open,
  closedReason,
  total,
  pending,
  closesOnText,
  onShare,
  onCopy,
}: InvitationPanelProps) {
  const progress =
    total === 0
      ? 'Todavía no hay integrantes cargados.'
      : pending === 0
        ? `Los ${String(total)} integrantes ya activaron su cuenta.`
        : `Faltan ${String(pending)} de ${String(total)} integrantes por activar su cuenta.`;
  return (
    <Card>
      <h2 className="text-lg font-bold">Invitá a tu grupo</h2>
      {open ? (
        <>
          <p className="mt-1 text-base text-muted">
            Cada persona abre el enlace, escribe su documento, elige su contraseña y ya puede elegir su habitación.{' '}
            {progress}
            {closesOnText !== undefined && ` El enlace funciona hasta el ${closesOnText}.`}
          </p>
          <div className="mt-4 flex flex-col gap-3 sm:flex-row">
            <Button onClick={onShare}>Compartir por WhatsApp</Button>
            <Button variant="secondary" onClick={onCopy}>
              Copiar enlace
            </Button>
          </div>
        </>
      ) : (
        <div className="mt-3">
          <Alert tone="info">{closedReason === null ? progress : CLOSED_TEXT[closedReason]}</Alert>
        </div>
      )}
    </Card>
  );
}
